var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C4.477 20.5 0 16.023 0 10.5C0 4.977 4.477 0.500003 10 0.500003C11.5527 0.498836 13.0842 0.859775 14.4729 1.55414C15.8617 2.24851 17.0693 3.25718 18 4.5H15.29C14.1352 3.48176 12.7112 2.81836 11.1887 2.5894C9.66625 2.36044 8.11007 2.57566 6.70689 3.20922C5.30371 3.84277 4.11315 4.86776 3.27807 6.16119C2.44299 7.45462 1.99887 8.96153 1.999 10.5011C1.99913 12.0407 2.4435 13.5475 3.27879 14.8408C4.11409 16.1341 5.30482 17.1589 6.7081 17.7922C8.11139 18.4255 9.66761 18.6405 11.19 18.4113C12.7125 18.1821 14.1364 17.5184 15.291 16.5H18.001C17.0702 17.743 15.8624 18.7517 14.4735 19.4461C13.0846 20.1405 11.5528 20.5013 10 20.5ZM17 14.5V11.5H9V9.5H17V6.5L22 10.5L17 14.5Z",
    fill: "#F94F01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.46578c7e.svg";
export { ForwardRef as ReactComponent };